export default `
/*
  Warnings:

  - You are about to drop the column \`name\` on the \`RawFile\` table. All the data in the column will be lost.

*/
-- CreateTable
CREATE TABLE "RawWorkspace" (
    "id" TEXT NOT NULL PRIMARY KEY,
    "workspace_id" TEXT NOT NULL,
    CONSTRAINT "RawWorkspace_workspace_id_fkey" FOREIGN KEY ("workspace_id") REFERENCES "Workspace" ("id") ON DELETE RESTRICT ON UPDATE CASCADE
);

-- CreateTable
CREATE TABLE "RawProject" (
    "id" TEXT NOT NULL PRIMARY KEY,
    "workspace_id" TEXT NOT NULL,
    CONSTRAINT "RawProject_workspace_id_fkey" FOREIGN KEY ("workspace_id") REFERENCES "Workspace" ("id") ON DELETE RESTRICT ON UPDATE CASCADE
);

-- CreateTable
CREATE TABLE "ProjectRevision" (
    "id" TEXT NOT NULL PRIMARY KEY,
    "project_id" TEXT NOT NULL,
    "workspace_id" TEXT NOT NULL,
    "revision_num" INTEGER NOT NULL,
    "revision_name" TEXT NOT NULL,
    "manual" BOOLEAN NOT NULL DEFAULT false,
    "created_by" TEXT NOT NULL,
    "created_at" DATETIME NOT NULL DEFAULT CURRENT_TIMESTAMP,
    CONSTRAINT "ProjectRevision_project_id_fkey" FOREIGN KEY ("project_id") REFERENCES "Project" ("id") ON DELETE RESTRICT ON UPDATE CASCADE,
    CONSTRAINT "ProjectRevision_workspace_id_fkey" FOREIGN KEY ("workspace_id") REFERENCES "Workspace" ("id") ON DELETE RESTRICT ON UPDATE CASCADE
);

-- CreateTable
CREATE TABLE "FileRevision" (
    "id" TEXT NOT NULL PRIMARY KEY,
    "revision_num" INTEGER NOT NULL,
    "revision_name" TEXT NOT NULL,
    "file_id" TEXT NOT NULL,
    "project_revision_id" TEXT,
    "created_by" TEXT NOT NULL,
    "created_at" DATETIME NOT NULL DEFAULT CURRENT_TIMESTAMP,
    "deleted_at" DATETIME,
    "workspace_id" TEXT NOT NULL,
    CONSTRAINT "FileRevision_file_id_fkey" FOREIGN KEY ("file_id") REFERENCES "File" ("id") ON DELETE RESTRICT ON UPDATE CASCADE,
    CONSTRAINT "FileRevision_project_revision_id_fkey" FOREIGN KEY ("project_revision_id") REFERENCES "ProjectRevision" ("id") ON DELETE SET NULL ON UPDATE CASCADE,
    CONSTRAINT "FileRevision_workspace_id_fkey" FOREIGN KEY ("workspace_id") REFERENCES "Workspace" ("id") ON DELETE RESTRICT ON UPDATE CASCADE
);

-- CreateTable
CREATE TABLE "AttributeRevision" (
    "id" TEXT NOT NULL PRIMARY KEY,
    "attribute_id" TEXT NOT NULL,
    "revision_num" INTEGER NOT NULL,
    "parent_revision_type" TEXT NOT NULL,
    "parent_revision_id" TEXT NOT NULL,
    "workspace_id" TEXT NOT NULL,
    "value" TEXT NOT NULL,
    "created_by" TEXT NOT NULL,
    "created_at" DATETIME NOT NULL DEFAULT CURRENT_TIMESTAMP,
    "projectRevisionId" TEXT,
    CONSTRAINT "AttributeRevision_attribute_id_fkey" FOREIGN KEY ("attribute_id") REFERENCES "Attribute" ("id") ON DELETE RESTRICT ON UPDATE CASCADE,
    CONSTRAINT "AttributeRevision_projectRevisionId_fkey" FOREIGN KEY ("projectRevisionId") REFERENCES "ProjectRevision" ("id") ON DELETE SET NULL ON UPDATE CASCADE,
    CONSTRAINT "AttributeRevision_workspace_id_fkey" FOREIGN KEY ("workspace_id") REFERENCES "Workspace" ("id") ON DELETE RESTRICT ON UPDATE CASCADE
);

-- RedefineTables
PRAGMA defer_foreign_keys=ON;
PRAGMA foreign_keys=OFF;
CREATE TABLE "new_File" (
    "id" TEXT NOT NULL PRIMARY KEY,
    "name" TEXT NOT NULL,
    "relative_path" TEXT NOT NULL,
    "mime_type" TEXT NOT NULL,
    "size" INTEGER NOT NULL,
    "earliest_known_modified_at" DATETIME,
    "workspace_id" TEXT NOT NULL,
    "created_by" TEXT NOT NULL,
    "created_at" DATETIME NOT NULL DEFAULT CURRENT_TIMESTAMP,
    "updated_at" DATETIME NOT NULL DEFAULT CURRENT_TIMESTAMP,
    "deleted_at" DATETIME,
    "versioning_mode" TEXT NOT NULL DEFAULT 'ATTACH',
    "auto_version" BOOLEAN NOT NULL DEFAULT false,
    CONSTRAINT "File_workspace_id_fkey" FOREIGN KEY ("workspace_id") REFERENCES "Workspace" ("id") ON DELETE RESTRICT ON UPDATE CASCADE,
    CONSTRAINT "File_created_by_fkey" FOREIGN KEY ("created_by") REFERENCES "User" ("id") ON DELETE RESTRICT ON UPDATE CASCADE
);
INSERT INTO "new_File" ("created_at", "created_by", "earliest_known_modified_at", "id", "mime_type", "name", "relative_path", "size", "updated_at", "workspace_id") SELECT "created_at", "created_by", "earliest_known_modified_at", "id", "mime_type", "name", "relative_path", "size", "updated_at", "workspace_id" FROM "File";
DROP TABLE "File";
ALTER TABLE "new_File" RENAME TO "File";
CREATE INDEX "File_mime_type_idx" ON "File"("mime_type");
CREATE INDEX "File_earliest_known_modified_at_idx" ON "File"("earliest_known_modified_at");
CREATE INDEX "File_workspace_id_idx" ON "File"("workspace_id");
CREATE INDEX "File_created_by_idx" ON "File"("created_by");
CREATE INDEX "File_created_at_idx" ON "File"("created_at");
CREATE INDEX "File_updated_at_idx" ON "File"("updated_at");
CREATE TABLE "new_RawFile" (
    "id" TEXT NOT NULL PRIMARY KEY,
    "file_id" TEXT NOT NULL,
    "full_path" TEXT NOT NULL,
    "workspace_id" TEXT NOT NULL,
    "created_by" TEXT NOT NULL,
    "created_at" DATETIME NOT NULL DEFAULT CURRENT_TIMESTAMP,
    "updated_at" DATETIME NOT NULL DEFAULT CURRENT_TIMESTAMP,
    "file_revision_id" TEXT,
    CONSTRAINT "RawFile_workspace_id_fkey" FOREIGN KEY ("workspace_id") REFERENCES "Workspace" ("id") ON DELETE RESTRICT ON UPDATE CASCADE,
    CONSTRAINT "RawFile_file_id_fkey" FOREIGN KEY ("file_id") REFERENCES "File" ("id") ON DELETE RESTRICT ON UPDATE CASCADE,
    CONSTRAINT "RawFile_file_revision_id_fkey" FOREIGN KEY ("file_revision_id") REFERENCES "FileRevision" ("id") ON DELETE SET NULL ON UPDATE CASCADE
);
INSERT INTO "new_RawFile" ("created_at", "created_by", "file_id", "full_path", "id", "updated_at", "workspace_id") SELECT "created_at", "created_by", "file_id", "full_path", "id", "updated_at", "workspace_id" FROM "RawFile";
DROP TABLE "RawFile";
ALTER TABLE "new_RawFile" RENAME TO "RawFile";
CREATE INDEX "RawFile_workspace_id_idx" ON "RawFile"("workspace_id");
CREATE INDEX "RawFile_file_id_idx" ON "RawFile"("file_id");
CREATE INDEX "RawFile_file_revision_id_idx" ON "RawFile"("file_revision_id");
CREATE INDEX "RawFile_created_by_idx" ON "RawFile"("created_by");
CREATE INDEX "RawFile_created_at_idx" ON "RawFile"("created_at");
CREATE INDEX "RawFile_updated_at_idx" ON "RawFile"("updated_at");
PRAGMA foreign_keys=ON;
PRAGMA defer_foreign_keys=OFF;

-- CreateIndex
CREATE INDEX "ProjectRevision_project_id_idx" ON "ProjectRevision"("project_id");

-- CreateIndex
CREATE INDEX "ProjectRevision_workspace_id_idx" ON "ProjectRevision"("workspace_id");

-- CreateIndex
CREATE INDEX "ProjectRevision_created_by_idx" ON "ProjectRevision"("created_by");

-- CreateIndex
CREATE INDEX "ProjectRevision_created_at_idx" ON "ProjectRevision"("created_at");

-- CreateIndex
CREATE INDEX "FileRevision_file_id_idx" ON "FileRevision"("file_id");

-- CreateIndex
CREATE INDEX "FileRevision_project_revision_id_idx" ON "FileRevision"("project_revision_id");

-- CreateIndex
CREATE INDEX "FileRevision_created_by_idx" ON "FileRevision"("created_by");

-- CreateIndex
CREATE INDEX "FileRevision_created_at_idx" ON "FileRevision"("created_at");

-- CreateIndex
CREATE INDEX "AttributeRevision_attribute_id_idx" ON "AttributeRevision"("attribute_id");

-- CreateIndex
CREATE INDEX "AttributeRevision_parent_revision_id_idx" ON "AttributeRevision"("parent_revision_id");

-- CreateIndex
CREATE INDEX "AttributeRevision_created_by_idx" ON "AttributeRevision"("created_by");

-- CreateIndex
CREATE INDEX "AttributeRevision_created_at_idx" ON "AttributeRevision"("created_at");
`;
